/** The device test battery: what a Quest session measures, in order. */

export interface CaseSpec {
  id: string;
  title: string;
  level: string;
  batch: "stable" | "default";
  churn: boolean;
  cull: boolean;
  systems?: string[];
  /** Seconds of frames to collect after a one-second settle. */
  seconds: number;
  /** What the tester should look for. */
  watch: string;
}

const FAR_STABLE: CaseSpec = { id: "far-stable", title: "far, stable batches", level: "far", batch: "stable", churn: false, cull: true, seconds: 8, watch: "baseline: the whole body at the far level" };

export const PLANS: Record<string, CaseSpec[]> = {
  full: [
    FAR_STABLE,
    { id: "far-default", title: "far, default BatchedMesh", level: "far", batch: "default", churn: false, cull: true, seconds: 8, watch: "same scene through three.js's default compaction: any flicker as you turn your head?" },
    { id: "far-stable-churn", title: "far, stable, visibility churn", level: "far", batch: "stable", churn: true, cull: true, seconds: 8, watch: "50 parts hidden and shown each frame; the stable slots should not flicker" },
    { id: "far-default-churn", title: "far, default, visibility churn", level: "far", batch: "default", churn: true, cull: true, seconds: 8, watch: "the hazard case: wrong parts drawn for a frame shows as flicker or colour swaps" },
    { id: "far-stable-nocull", title: "far, stable, no per-frame culling", level: "far", batch: "stable", churn: false, cull: false, seconds: 6, watch: "the cost of culling itself: compare frame time with the baseline" },
    { id: "near-stable", title: "near, stable batches", level: "near", batch: "stable", churn: false, cull: true, seconds: 8, watch: "the Quest 3 default quality: does it hold 72 Hz?" },
    { id: "near-default-churn", title: "near, default, visibility churn", level: "near", batch: "default", churn: true, cull: true, seconds: 6, watch: "the hazard at the near level" },
    { id: "far-skeleton", title: "far, skeleton only", level: "far", batch: "stable", churn: false, cull: true, systems: ["skeletal"], seconds: 6, watch: "one batch: the floor of the draw-call cost" },
    { id: "hero-stable", title: "hero, stable batches (stress)", level: "hero", batch: "stable", churn: false, cull: true, seconds: 6, watch: "the whole body at hero, which the client never draws: a stress reading only" },
  ],
  quick: [
    { ...FAR_STABLE, seconds: 2 },
    { id: "far-default-churn", title: "far, default, visibility churn", level: "far", batch: "default", churn: true, cull: true, seconds: 2, watch: "the hazard case" },
  ],
};
